/* Priva product page — interactive step wizard configurator.

   The configurator is a guided, multi-step builder for THE CURRENT device:
     Step 1: choose the device variant(s) — selectable image tiles
     Step 2: add plates (Packer & Duo only) — optional, skippable
     Step 3: add attachments (all devices) — optional, skippable
   Tugger / Air have only 2 steps (device + attachments).

   When the device has only ONE variant the "Choose your device" step is
   dropped — there is nothing to choose — and the lone variant is added to
   the order automatically at quantity 1. The wizard then starts at the
   first add-on step and the progress indicator reflects the reduced count.
   The device still appears in the "Your configuration" summary panel with a
   quantity stepper, so the customer can still buy more than one.

   One step is visible at a time. A progress indicator (label + bar + dots)
   tracks position. Each option is a visual tile: image, name, price. Clicking
   a tile selects it and reveals an on-tile quantity control. Next / Back
   navigate; on the final step the primary button becomes the add-to-cart action.
   A persistent summary panel shows selections + running total on every step.

   The running selection is local; it is committed in a single /cart/add.js
   POST at "Add to cart". The cart bar / header count refreshes so the
   customer sees the items were added — no redirect to /checkout.

   All product/variant data comes from the #shop-config-data JSON block
   emitted by sections/main-product.liquid (real Shopify IDs and prices).
*/

(function () {
  var dataEl = document.getElementById('shop-config-data');
  if (!dataEl) return;

  function waitForPriva(retriesLeft) {
    if (window.Priva && typeof window.Priva.fetchCart === 'function') {
      init();
    } else if (retriesLeft > 0) {
      setTimeout(function () { waitForPriva(retriesLeft - 1); }, 30);
    } else {
      // The wizard still works standalone; only the global cart bar relies on Priva.
      init();
    }
  }
  waitForPriva(40);

  function init() {
    if (init.done) return;
    init.done = true;

    var DATA;
    try {
      DATA = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('Could not parse shop-config-data', err);
      return;
    }

    var device = DATA.device;
    if (!device || !device.variants || !device.variants.length) return;
    var plates = DATA.plates || [];
    var attachments = DATA.attachments || [];
    var usesPlates = !!DATA.usesPlates;
    // EU/EEA visitors (Omnibus Directive): show only the price, no struck
    // reference price or percent-off.
    var hideReference = !!DATA.hideReference;

    function money(cents) {
      // Format in the shopper's active currency (Shopify sets Shopify.currency.active),
      // dropping ".00" on whole amounts like the rest of the site.
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      var whole = cents % 100 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency', currency: cur,
          minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
        }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
      }
    }
    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    // ----- DOM refs -----
    var $wizard = document.getElementById('configBuilder');
    var $panes = document.getElementById('wizPanes');
    var $variantList = document.getElementById('variantList');
    var $platesList = document.getElementById('platesList');
    var $attachmentsList = document.getElementById('attachmentsList');

    var $progressFill = document.getElementById('wizProgressFill');
    var $stepLabel = document.getElementById('wizStepLabel');
    var $stepName = document.getElementById('wizStepName');
    var $stepSub = document.getElementById('wizStepSub');
    var $stepOptional = document.getElementById('wizStepOptional');
    var $dots = document.getElementById('wizDots');

    var $back = document.getElementById('wizBack');
    var $skip = document.getElementById('wizSkip');
    var $next = document.getElementById('wizNext');

    var $cartBar = document.getElementById('cartBar');
    var $cartItems = document.getElementById('cartItems');
    var $cartTotal = document.getElementById('cartTotal');
    var $cartCheckoutBtn = $cartBar ? $cartBar.querySelector('.cart-checkout') : null;

    var $summaryLines = document.getElementById('configSummaryLines');
    var $summaryTotal = document.getElementById('configSummaryTotal');
    var $summaryCheckout = document.getElementById('configCheckout');

    // ----- State -----
    var state = {
      devices: {}, // device variant id -> qty
      addons: {}   // addon variant id -> qty (plates + attachments combined)
    };

    function findAddon(id) {
      var all = plates.concat(attachments);
      return all.filter(function (x) { return String(x.id) === String(id); })[0];
    }
    function findDeviceVariant(id) {
      return device.variants.filter(function (v) {
        return String(v.id) === String(id);
      })[0];
    }
    // Build tile-shaped rows for each device variant. On a multi-variant
    // device the tile shows just the variant name (e.g. "Classic") — the
    // full product name would overrun the small tile and is redundant
    // since you're already on that product's page.
    function deviceRows() {
      var multi = device.variants.length > 1;
      return device.variants.map(function (v) {
        return {
          id: v.id,
          title: multi ? v.title : device.title,
          // A pre-order price (mirroring the automatic discount) shows as the
          // price, with the list price struck through.
          price: v.preorderPrice || v.price,
          compareAt: v.preorderPrice ? v.price : (v.compareAt || 0),
          preorder: !!v.preorder,
          available: v.available,
          image: v.image || '',
          description: ''
        };
      });
    }

    // ----- Step model -----
    // Each step: { key, name, store, optional, items }
    //
    // When the device has a single variant the "Choose your device" step is
    // pointless — there is nothing to choose — so it is dropped entirely. The
    // lone variant is added to the order automatically at quantity 1; the
    // customer can still change the quantity from the summary panel.
    var singleVariant = device.variants.length === 1;
    if (singleVariant) {
      state.devices[device.variants[0].id] = 1;
    }

    var steps = [];
    if (!singleVariant) {
      steps.push({ key: 'variants', name: 'Choose your device',
        desc: 'Pick a device and set the quantity.',
        store: state.devices, optional: false, items: deviceRows() });
    }
    if (usesPlates && plates.length) {
      steps.push({ key: 'plates', name: 'Add plates',
        desc: 'Classic 10 mm plates stack to add length. The Notched 15 mm plate leaves room for the frenulum.',
        store: state.addons, optional: true, items: plates });
    }
    if (attachments.length) {
      steps.push({ key: 'attachments', name: 'Add attachments',
        desc: 'Add straps, weights and adapters.',
        store: state.addons, optional: true, items: attachments });
    }
    // A single-variant device with no add-on steps has nothing to wizard
    // through — the device is already in the order, so just show the summary.
    if (!steps.length) {
      if ($wizard) {
        var $progressEl = document.getElementById('wizProgress');
        if ($progressEl) $progressEl.hidden = true;
        var $mainEl = $wizard.querySelector('.wiz-main');
        if ($mainEl) $mainEl.hidden = true;
      }
      var $headZero = document.getElementById('wizStepHead');
      if ($headZero) $headZero.hidden = true;
      updateSummary();
      return;
    }

    // When only one step remains (e.g. Tugger / Air: device is fixed, the
    // single step is "add attachments") there is no wizard to step through.
    // Drop the progress bar / "Step 1 of 1" counter and the Next/Back nav so
    // it reads as a simple "add attachments" picker, not a configurator.
    if (steps.length === 1) {
      // Hide the step counter / bar / dots but keep the step heading.
      var $progressNavOne = document.getElementById('wizProgressNav');
      if ($progressNavOne) $progressNavOne.hidden = true;
      var $navOne = $wizard ? $wizard.querySelector('.wiz-nav') : null;
      if ($navOne) $navOne.style.display = 'none';
    }
    var current = 0;

    // The configurator owns the global cart bar while this page is open.
    if ($cartBar) $cartBar.dataset.configuratorActive = '1';

    // ----- Render tiles -----
    function listFor(key) {
      if (key === 'variants') return $variantList;
      if (key === 'plates') return $platesList;
      if (key === 'attachments') return $attachmentsList;
      return null;
    }

    function renderTiles(step) {
      var $container = listFor(step.key);
      if (!$container) return;
      var store = step.store;
      $container.innerHTML = step.items.map(function (a) {
        var qty = store[a.id] || 0;
        var selected = qty > 0;
        var soldOut = a.available === false;
        var thumb = a.image
          ? '<img class="tile-img" src="' + escapeHtml(a.image) + '" alt="' + escapeHtml(a.title) + '" loading="lazy">'
          : '<div class="tile-img tile-img--empty">' + escapeHtml((a.title || '?').charAt(0)) + '</div>';
        var discounted = !hideReference && a.compareAt && a.compareAt > a.price;
        var priceHtml = '<div class="tile-price">' + money(a.price);
        if (discounted) {
          var save = Math.round((a.compareAt - a.price) * 100 / a.compareAt);
          priceHtml += ' <span class="tile-was">' + money(a.compareAt) + '</span>' +
                       ' <span class="tile-save">−' + save + '%</span>';
        }
        priceHtml += '</div>';
        var preorderBadge = a.preorder ? '<span class="tile-badge">Pre-order</span>' : '';
        return '' +
          '<div class="tile' + (selected ? ' is-selected' : '') + (soldOut ? ' is-soldout' : '') + '" ' +
               'data-tile="' + a.id + '" role="button" tabindex="0" ' +
               'aria-pressed="' + (selected ? 'true' : 'false') + '">' +
            '<span class="tile-check" aria-hidden="true">✓</span>' +
            preorderBadge +
            '<div class="tile-media">' + thumb + '</div>' +
            '<div class="tile-name">' + escapeHtml(a.title) +
              (soldOut ? ' <span class="tile-soldout">Sold out</span>' : '') + '</div>' +
            priceHtml +
            '<div class="tile-foot">' +
              '<span class="tile-add">+ Add</span>' +
              '<div class="tile-qty" aria-label="Quantity">' +
                '<button class="qty-btn" type="button" data-delta="-1" aria-label="Decrease">−</button>' +
                '<span class="qty-value" data-qty="' + a.id + '">' + qty + '</span>' +
                '<button class="qty-btn" type="button" data-delta="1" aria-label="Increase">+</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');

      bindTiles($container, store);
    }

    function bindTiles($container, store) {
      $container.querySelectorAll('.tile').forEach(function (tile) {
        var id = parseInt(tile.dataset.tile, 10);
        if (tile.classList.contains('is-soldout')) return;

        // Click anywhere on the tile (outside qty controls) toggles selection.
        tile.addEventListener('click', function (e) {
          if (e.target.closest('.tile-qty')) return;
          var qty = store[id] || 0;
          setQty($container, store, id, qty > 0 ? 0 : 1);
        });
        tile.addEventListener('keydown', function (e) {
          // Ignore keys bubbling up from the nested qty buttons, so Enter/Space
          // on − / + steps the quantity instead of toggling the whole tile.
          if (e.target !== tile) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var qty = store[id] || 0;
            setQty($container, store, id, qty > 0 ? 0 : 1);
          }
        });

        tile.querySelectorAll('[data-delta]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var delta = parseInt(btn.dataset.delta, 10);
            setQty($container, store, id, (store[id] || 0) + delta);
          });
        });
      });
    }

    function setQty($container, store, id, next) {
      next = Math.max(0, next);
      if (next === 0) delete store[id];
      else store[id] = next;

      var tile = $container.querySelector('[data-tile="' + id + '"]');
      if (tile) {
        var selected = next > 0;
        tile.classList.toggle('is-selected', selected);
        tile.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var qtyEl = tile.querySelector('[data-qty="' + id + '"]');
        if (qtyEl) qtyEl.textContent = next;
      }
      updateSummary();
      updateNav();
      updateProgressBar();
    }

    // The progress bar reflects how far along you are: each completed
    // step counts, and the current step counts once it has a selection —
    // so picking something on a step visibly advances the bar.
    function updateProgressBar() {
      var filled = current + (stepComplete(current) ? 1 : 0);
      var pct = steps.length ? (filled / steps.length) * 100 : 100;
      $progressFill.style.width = pct + '%';
    }

    // ----- Progress indicator -----
    function renderProgress() {
      $dots.innerHTML = steps.map(function (s, i) {
        var cls = 'wiz-dot';
        if (i < current) cls += ' is-done';
        else if (i === current) cls += ' is-active';
        return '<span class="' + cls + '" data-dot="' + i + '">' +
          '<span class="wiz-dot-num">' + (i + 1) + '</span>' +
          '<span class="wiz-dot-label">' + escapeHtml(s.name) + '</span>' +
        '</span>';
      }).join('');

      // Dots are clickable to jump to any already-reachable step.
      $dots.querySelectorAll('[data-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var target = parseInt(dot.dataset.dot, 10);
          if (target <= current || canAdvanceTo(target)) goToStep(target);
        });
      });

      updateProgressBar();
      $stepLabel.textContent = 'Step ' + (current + 1) + ' of ' + steps.length;
      $stepName.textContent = steps[current].name;
      if ($stepSub) $stepSub.textContent = steps[current].desc || '';
      if ($stepOptional) $stepOptional.hidden = !steps[current].optional;
    }

    // Step 1 requires a device; optional steps are always passable.
    function stepComplete(i) {
      var s = steps[i];
      if (s.optional) return true;
      return Object.keys(s.store).length > 0;
    }
    function canAdvanceTo(target) {
      for (var i = 0; i < target; i++) {
        if (!stepComplete(i)) return false;
      }
      return true;
    }

    // ----- Pane navigation -----
    function showPane() {
      var panes = $panes.querySelectorAll('.wiz-pane');
      panes.forEach(function (p) {
        var active = p.dataset.pane === steps[current].key;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
    }

    function goToStep(i) {
      if (i < 0 || i >= steps.length) return;
      var forward = i > current;
      current = i;
      $panes.classList.remove('slide-in');
      // Force reflow so the animation re-triggers.
      void $panes.offsetWidth;
      $panes.classList.add('slide-in');
      $panes.dataset.dir = forward ? 'fwd' : 'back';
      showPane();
      renderProgress();
      updateNav();
    }

    function updateNav() {
      var isFirst = current === 0;
      var isLast = current === steps.length - 1;
      $back.hidden = isFirst;

      var step = steps[current];
      var hasSelection = Object.keys(step.store).length > 0;

      // Skip shows on optional steps with nothing selected.
      $skip.hidden = !(step.optional && !hasSelection) || isLast;

      // On the last step the wizard's Next button is hidden: the persistent
      // summary panel's "Add to cart" button is the single checkout action.
      if (isLast) {
        $next.hidden = true;
      } else {
        $next.hidden = false;
        $next.classList.remove('wiz-btn--checkout');
        $next.disabled = !stepComplete(current);
        $next.textContent = 'Next';
      }
    }

    $back.addEventListener('click', function () {
      goToStep(current - 1);
    });
    $skip.addEventListener('click', function () {
      if (current < steps.length - 1) goToStep(current + 1);
    });
    $next.addEventListener('click', function () {
      // The last step has no Next button — checkout is the summary panel
      // button — so this only ever advances the wizard.
      if (current === steps.length - 1) return;
      if (!stepComplete(current)) {
        flashIncomplete();
        return;
      }
      goToStep(current + 1);
    });

    function flashIncomplete() {
      var $vp = $panes.querySelector('.wiz-pane.is-active');
      if (!$vp) return;
      $vp.classList.remove('shake');
      void $vp.offsetWidth;
      $vp.classList.add('shake');
    }

    // Adjust quantity for any id from outside its step pane (e.g. the
    // summary steppers). Updates state, syncs the matching step tile if it
    // is rendered, then refreshes the summary, cart bar and nav.
    function adjustQty(kind, id, next) {
      var store = kind === 'device' ? state.devices : state.addons;
      next = Math.max(0, next);
      // On a single-variant build (Duo, Air) the device step is skipped,
      // so there is no tile to re-add the device from — don't let its
      // quantity drop below 1.
      if (kind === 'device' && singleVariant) next = Math.max(1, next);
      if (next === 0) delete store[id];
      else store[id] = next;

      // Keep the corresponding wizard tile in sync if it exists in the DOM.
      var tile = $panes
        ? $panes.querySelector('[data-tile="' + id + '"]')
        : null;
      if (tile) {
        var selected = next > 0;
        tile.classList.toggle('is-selected', selected);
        tile.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var qtyEl = tile.querySelector('[data-qty="' + id + '"]');
        if (qtyEl) qtyEl.textContent = next;
      }
      updateSummary();
      updateNav();
      updateProgressBar();
    }

    function bindSummarySteppers() {
      if (!$summaryLines) return;
      $summaryLines.querySelectorAll('.cs-line').forEach(function (line) {
        var id = parseInt(line.dataset.csLine, 10);
        var kind = line.dataset.csKind;
        var store = kind === 'device' ? state.devices : state.addons;
        line.querySelectorAll('[data-cs-delta]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var delta = parseInt(btn.dataset.csDelta, 10);
            adjustQty(kind, id, (store[id] || 0) + delta);
          });
        });
      });
    }

    // ----- Summary panel + cart bar -----
    function updateSummary() {
      var total = 0;
      var lines = [];   // plain strings, for the sticky cart bar
      var rows = [];    // { label, qty, amount }, for the summary panel
      var multi = device.variants.length > 1;

      Object.keys(state.devices).forEach(function (id) {
        var v = findDeviceVariant(id);
        if (!v) return;
        var qty = state.devices[id];
        var amount = (v.preorderPrice || v.price) * qty;
        total += amount;
        var label = device.title + (multi ? ', ' + v.title : '');
        lines.push(qty + ' × ' + label);
        rows.push({ id: id, kind: 'device', label: label, qty: qty, amount: amount });
      });

      Object.keys(state.addons).forEach(function (id) {
        var a = findAddon(id);
        if (!a) return;
        var qty = state.addons[id];
        var amount = a.price * qty;
        total += amount;
        lines.push(qty + ' × ' + a.title);
        rows.push({ id: id, kind: 'addon', label: a.title, qty: qty, amount: amount });
      });

      var hasItems = rows.length > 0;

      if ($summaryLines) {
        if (!hasItems) {
          $summaryLines.innerHTML =
            '<p class="cs-empty">Nothing selected yet — start by choosing a device.</p>';
        } else {
          $summaryLines.innerHTML = rows.map(function (r) {
            return '<div class="cs-line" data-cs-line="' + r.id + '" data-cs-kind="' + r.kind + '">' +
              '<div class="cs-line-stepper" aria-label="Quantity">' +
                '<button type="button" class="cs-step" data-cs-delta="-1" aria-label="Decrease">−</button>' +
                '<span class="cs-line-qty" data-cs-qty>' + r.qty + '</span>' +
                '<button type="button" class="cs-step" data-cs-delta="1" aria-label="Increase">+</button>' +
              '</div>' +
              '<span class="cs-line-label">' + escapeHtml(r.label) + '</span>' +
              '<span class="cs-line-amount">' + money(r.amount) + '</span>' +
            '</div>';
          }).join('');
          bindSummarySteppers();
        }
      }
      if ($summaryTotal) $summaryTotal.textContent = money(total);
      if ($summaryCheckout) $summaryCheckout.disabled = !hasItems;

      if ($cartBar) {
        if (!hasItems) {
          $cartBar.hidden = true;
          $cartBar.classList.remove('active');
        } else {
          if ($cartItems) {
            $cartItems.innerHTML = lines.map(function (l) {
              return '<span class="cart-line">' + escapeHtml(l) + '</span>';
            }).join('');
          }
          if ($cartTotal) $cartTotal.textContent = money(total);
          $cartBar.hidden = false;
          requestAnimationFrame(function () { $cartBar.classList.add('active'); });
        }
      }
    }

    // ----- Add to cart: single /cart/add.js POST, refresh cart, no redirect -----
    async function addToCart(btn) {
      var items = [];
      Object.keys(state.devices).forEach(function (id) {
        items.push({ id: parseInt(id, 10), quantity: state.devices[id] });
      });
      Object.keys(state.addons).forEach(function (id) {
        items.push({ id: parseInt(id, 10), quantity: state.addons[id] });
      });
      if (!items.length) {
        // Send the customer back to step 1 to pick a device.
        goToStep(0);
        flashIncomplete();
        return;
      }

      var originalText = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';
      btn.style.pointerEvents = 'none';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!res.ok) {
          var errBody = await res.json().catch(function () { return {}; });
          throw new Error(errBody.description || 'Could not add to cart.');
        }

        // Refresh the global cart bar / header count so the customer sees
        // the items landed — but stay on the page, no redirect.
        if (window.Priva && typeof window.Priva.fetchCart === 'function') {
          try {
            var cart = await window.Priva.fetchCart();
            if (typeof window.Priva.renderCart === 'function') {
              window.Priva.renderCart(cart);
            }
          } catch (cartErr) {
            console.warn('Cart refresh failed after add', cartErr);
          }
        }

        // Brief confirmation, then restore the button label.
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = originalText;
          btn.style.pointerEvents = '';
        }, 2200);
      } catch (err) {
        console.error('Configurator add to cart failed', err);
        alert(err.message || 'Sorry, could not add to cart. Please try again.');
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
        btn.style.pointerEvents = '';
      }
    }

    [$cartCheckoutBtn, $summaryCheckout].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn);
      });
    });

    // ----- "Configure" CTA buttons scroll to the configurator -----
    document.querySelectorAll('[data-scroll-to-configurator]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('configurator');
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // ----- Boot -----
    steps.forEach(function (s) { renderTiles(s); });
    showPane();
    renderProgress();
    updateNav();
    updateSummary();
  } // end init
})();
